import React, { createContext, useContext } from 'react';

/**
 * knz 本文中の外部ファイル参照（例: CodeBlock の link）を解決するためのファイル取得関数。
 *
 * 描画コンテキストによって参照先ファイルの取得APIが異なる:
 * - ワークスペース（編集）: 認証必須のファイル詳細取得API（getFileDetail / GET_WORKSPACE_FILE）
 * - 記事詳細（ゲスト閲覧可）: 公開用ファイル取得API（getPublicArticleFile / API6111）
 *
 * この差異を吸収するため、参照先ファイルの取得を resolver として注入する。
 * 未提供の場合、各 embed は従来どおり認証必須APIにフォールバックする。
 */
export type KnzResolvedFile = {
  fileId: string;
  extension: string;
  detail: string;
  /** ファイル名（取得できる場合のみ。公開用APIは名前を返さないため任意） */
  name?: string;
  /** 絶対パス（取得できる場合のみ。ワークスペース経由のみ。公開用APIは返さないため任意） */
  path?: string;
};

export type KnzFileResolver = (fileId: string) => Promise<KnzResolvedFile>;

const KnzFileResolverContext = createContext<KnzFileResolver | null>(null);

/** 参照先ファイル取得 resolver を取得する（未提供なら null）。 */
export const useKnzFileResolver = (): KnzFileResolver | null => {
  return useContext(KnzFileResolverContext);
};

export const KnzFileResolverProvider: React.FC<{
  resolver: KnzFileResolver | null;
  children: React.ReactNode;
}> = ({ resolver, children }) => {
  return (
    <KnzFileResolverContext.Provider value={resolver}>{children}</KnzFileResolverContext.Provider>
  );
};
